// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__5cWNK","error":"InputSecondary_error__3-bmf","disabled":"InputSecondary_disabled__1rpoT"};